import getPlatformFromId from "@utils/priceAndCurrencyMethods/getPlatformFromId";

const findPriceWithTier = (tiersList, tier, id) => {
    const platform = getPlatformFromId(id);
    const tiersObj = tiersList.find(obj => obj.tier === tier);
    return tiersObj?.[platform]?.USD || tiersObj?.ios?.USD || null;
};

export default findPriceWithTier;